uic-app-header {
    display: block;
    width: 100%;
    height: var(--uic-header-height);

    uic-header {
        position: fixed;
        left: 0;
        top: 0;
    }
}
